import sumEnabledRowsInCategory from './helpers/sumEnabledRowsInCategory'

export default (form) => sumEnabledRowsInCategory(form, 'monthlyExpenses')
